var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHomeCircle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.182,
    height: 24.182,
    viewBox: "0 0 24.182 24.182",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_25197",
    "data-name": "Group 25197",
    transform: "translate(-47 -529)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_24402",
    "data-name": "Group 24402",
    transform: "translate(-1188.999 207.091)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1545",
    "data-name": "Ellipse 1545",
    cx: 12.091,
    cy: 12.091,
    r: 12.091,
    transform: "translate(1235.999 321.909)",
    fill: "#396"
  })), /*#__PURE__*/React.createElement("path", {
    id: "home",
    d: "M12.443,5.715,6.6.11a.4.4,0,0,0-.547,0L.195,5.721A.668.668,0,0,0,0,6.19a.66.66,0,0,0,.659.659H1.58v5a.791.791,0,0,0,.79.79H4.61a.4.4,0,0,0,.4-.4V8.824a.132.132,0,0,1,.132-.132H7.507a.132.132,0,0,1,.132.132v3.424a.4.4,0,0,0,.4.4h2.239a.791.791,0,0,0,.79-.79v-5h.922a.66.66,0,0,0,.659-.659.673.673,0,0,0-.2-.475Zm0,0",
    transform: "translate(53.085 534.769)",
    fill: "#fff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeCircle);
export default __webpack_public_path__ + "static/media/home-circle.7cb19f3e420ffede557958094fe8480a.svg";
export { ForwardRef as ReactComponent };